import React from 'react';
import styles from './ImagePlaceholder.module.css';

type Props = {
  label?: string;
  ratio?: string;
  radius?: number;
  dark?: boolean;
  fill?: boolean;
  className?: string;
  style?: React.CSSProperties;
};

const ImagePlaceholder: React.FC<Props> = ({
  label = 'Image',
  ratio,
  radius = 12,
  dark = false,
  fill = false,
  className,
  style,
}) => (
  <div
    className={className ? `${styles.box} ${className}` : styles.box}
    style={
      {
        ['--ph-radius' as string]: `${radius}px`,
        ...(!fill && ratio ? { ['--ph-ratio' as string]: ratio } : {}),
        ...style,
      } as React.CSSProperties
    }
    data-dark={dark ? 'true' : 'false'}
    data-fill={fill ? 'true' : 'false'}
    aria-hidden="true"
  >
    {label}
  </div>
);

export default ImagePlaceholder;
